import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type StudyMaterialIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function StudyMaterialIcon({
  className,
  pathClassName = "stroke-gray-800",
  ...props
}: StudyMaterialIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M14.185 2.753v3.596c0 .487.195.955.541 1.3a1.85 1.85 0 001.305.539h4.125"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.25 8.568v8.568a4.251 4.251 0 01-1.362 2.97 4.283 4.283 0 01-3.072 1.14h-7.59a4.294 4.294 0 01-3.1-1.124 4.265 4.265 0 01-1.376-2.986V6.862a4.25 4.25 0 011.362-2.97 4.283 4.283 0 013.072-1.14h5.714a3.503 3.503 0 012.361.905l2.96 2.722a2.971 2.971 0 011.031 2.189z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.646 7.647h3.265M7.646 12h8.706M7.646 16.353h8.706"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default StudyMaterialIcon;
